import type { AdTraffickingColumnFragment } from '../../../../../../../../apis/graphql/types';
import type { TagSheetSaveResult } from '../../../../types';
import { isAdEntitySuccess, isAdSuccessfullyCreated } from '../../../../utils/createAdsWithCreativesOutcome';

export const getSuccessfullyCreatedAds = (result: TagSheetSaveResult): AdTraffickingColumnFragment[] =>
  result.lineItems
    .flatMap((lineItem) => lineItem.ads)
    .reduce<AdTraffickingColumnFragment[]>((acc, adItem) => {
      if (isAdSuccessfullyCreated(adItem) && isAdEntitySuccess(adItem.adEntity)) {
        acc.push(adItem.adEntity);
      }

      return acc;
    }, []);
